import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const CreatePatchPage = lazy(
  () => import('@/features/Servers/pages/CreatePatchPage'),
)

export const Route = createFileRoute('/infra/servers/$id/create-patch')({
  loader: () => ({
    crumb: 'Create Patch',
  }),
  beforeLoad: protectedRouteGuard,
  component: () => (
    <Suspense fallback={<Loading />}>
      <CreatePatchPage />
    </Suspense>
  ),
})
